// Aggregated remediation recommendations — one accordion for all intents.

import React from "react";

import { DETECTION_ICONS } from "../../../../../icons/detectionLucideIcons";
import {
  DrawerNumberedList,
  SmartParseSectionCard,
} from "./smartParseDrawerUi";

export function collectRemediation(intents) {
  const seen = new Set();
  const items = [];
  if (!Array.isArray(intents)) return items;

  for (const intent of intents) {
    if (!Array.isArray(intent?.remediation)) continue;
    for (const entry of intent.remediation) {
      const text = typeof entry === "string" ? entry.trim() : "";
      if (text && !seen.has(text)) {
        seen.add(text);
        items.push(text);
      }
    }
  }

  return items;
}

export default function RemediationSection({ intents }) {
  const items = collectRemediation(intents);
  if (items.length === 0) return null;

  return (
    <SmartParseSectionCard
      icon={DETECTION_ICONS.wrench}
      title="Remediation"
      count={items.length}
    >
      <DrawerNumberedList
        items={items}
        variant="rem"
        subtitle="Recommended actions to reduce exposure to similar attacks."
      />
    </SmartParseSectionCard>
  );
}
